<div class="popup-content">
  <div class="heading-part">
    <h1>Likes</h1>
    <p class="new-text">{{ LikeCounts || 0 }}</p>

    <span class="close" (click)="onClose()" [innerHTML]="ICONS.closeCircleIcon | safeHtml"></span>
  </div>
  <div class="user__popup__list">
    <div
      class="user__popup"
      *ngFor="let data of likesList; let i = index"
      infiniteScroll
      [infiniteScrollDistance]="10"
      [infiniteScrollThrottle]="150"
      (scrolled)="nextToken != null ? likeFeedList() : null"
    >
      <div class="user__infos">
        <img
          *ngIf="data.user?.profilePicture"
          [src]="fileDirectoriesPath + data.user?.profilePicture"
          alt="User Image"
          class="user__images {{ userDetail.id == data?.userId ? 'row--highlight' : '' }}"
        />
        <div class="user__detail">
          <h2 class="user__name">{{ data.user?.alias ? data.user?.alias || '-' : data?.user?.name || '-' }}</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="searchResult" *ngIf="likesList.length == 0">
    <div class="searching text-center">
      <h5>No record found!</h5>
    </div>
  </div>
</div>
